import { useContext } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';
import { Modal, ThemeContext } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import RequestSettingForm from './RequestSettingForm';
import { useRequestSetting } from './useRequestSetting';

import styles from './request-setting-modal.module.css';

const RequestSettingModal = ({ open, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const { lang } = useContext(ThemeContext);

  const { onSubmit, isSuccess, isError, isLoading, reset } = useRequestSetting({ lang });

  const handleSubmit = (values) => {
    onSubmit(values).then(success => {
      if (success) {
        onSuccess();
        // analytics.sendRequestForm();
      }
    });
  };

  const handleClose = () => {
    reset();
    onClose(false);
  };

  let title = <>
    <div className={styles.titleText}>Получите готовый шаблон бесплатно</div>
    <div className={styles.subtitle}>
      Заполните поля ниже и загрузите документ, чтобы получить готовый настроенный шаблон.
    </div>
  </>;

  if (isSuccess) title = <>
    <div className={styles.titleText}>Спасибо!</div>
    <div className={styles.subtitle}>
      Менеджер свяжется с вами, чтобы уточнить детали по документу и более подробно расскажет о возможностях сервиса.
    </div>
  </>;

  if (isError) title = <>
    <div className={styles.titleText}>Ошибка!</div>
    <div className={styles.subtitle}>
      Проверьте заполнение полей и попробуйте позже.
    </div>
  </>;

  return (
    <ClientWrap>
      <Modal
        open={open}
        onClose={handleClose}
        title={title}
        titleClassName={classNames(styles.title, (isSuccess || isError) && styles.titleResult)}
        width="100%"
        maxWidth="576px"
      >
        {(!isSuccess && !isError) && (
          <RequestSettingForm
            onSubmit={handleSubmit}
            isSendSuccess={isSuccess}
            isSendError={isError}
            isSendLoading={isLoading}
            buttonText={t('send')}
            noticeText={
              <Trans
                i18nKey="user_agreement_form_notice"
                components={{
                  privacy: <Link href="/privacy" target="_blank" />,
                  license: <Link href="/license" target="_blank" />,
                  button: t('send'),
                }}
              />
            }
          />
        )}
      </Modal>
    </ClientWrap>
  );
};

export default RequestSettingModal;
